const THEME_STORAGE_KEY = 'preferredTheme';
const SUPPORTED_THEMES = ['light', 'dark'] as const;

export type PreferredTheme = typeof SUPPORTED_THEMES[number];

function normalizeTheme(value: unknown): PreferredTheme | null {
  return value === 'light' || value === 'dark' ? value : null;
}

export function getSupportedThemes(): ReadonlyArray<PreferredTheme> {
  return SUPPORTED_THEMES;
}

export function getPreferredTheme(): PreferredTheme {
  try {
    return normalizeTheme(localStorage.getItem(THEME_STORAGE_KEY)) ?? 'light';
  } catch {
    return 'light';
  }
}

export function setPreferredTheme(value: unknown): PreferredTheme | null {
  const theme = normalizeTheme(value);
  if (!theme) {
    return null;
  }
  try {
    localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch {
    // no-op
  }
  applyPreferredTheme(theme);
  return theme;
}

export function applyPreferredTheme(theme?: PreferredTheme): void {
  if (typeof document === 'undefined') {
    return;
  }
  const explicitTheme = theme ?? readStoredTheme();
  document.documentElement.classList.toggle('dark', explicitTheme === 'dark');
  document.documentElement.classList.toggle('light', explicitTheme === 'light');
  document.body.classList.toggle('dark', explicitTheme === 'dark');
  document.body.classList.toggle('light', explicitTheme === 'light');
}

function readStoredTheme(): PreferredTheme | null {
  try {
    return normalizeTheme(localStorage.getItem(THEME_STORAGE_KEY));
  } catch {
    return null;
  }
}
